<template>
  <div class="footer">
    <div class="footer__container container">
      <div class="footer__items">
        <div class="footer__item">
          <a href="https://topliga.ru/" class="footer__logo">
            <img src="./TopLiga-Footer.svg" alt="footer-logo" width="248">
          </a>
          <div class="footer__social">
            <a
              v-for="item in socials"
              :key="item.icon"
              class="footer__social-item"
              :href="item.link"
              target="_blank"
            >
              <img :src="require(`./${item.icon}.svg`)">
            </a>
          </div>

          <p class="text-xs">{{ copyright }} {{ year }}</p>
        </div>

        <div class="footer__item">
          <div class="footer__links">
            <RrLink
              v-for="(link) in links.slice(0, 3)"
              :key="link.text"
              class="color-white"
              :text="link.text"
              :href="link.link"
              target="_blank"
              variant="inherit"
              size="lg"
            />
          </div>
        </div>

        <div class="footer__item">
          <div class="footer__links">
            <RrLink
              v-for="(link) in links.slice(3, 6)"
              :key="link.text"
              class="color-white"
              :text="link.text"
              :href="link.link"
              target="_blank"
              variant="inherit"
              size="lg"
            />
          </div>
        </div>

        <div class="footer__item">
          <div class="footer__links">
            <RrLink
              v-for="(link) in links.slice(6)"
              :key="link.text"
              class="color-white"
              :text="link.text"
              :href="link.link"
              target="_blank"
              variant="inherit"
              size="lg"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RrLink from '@rr-component-library/link/src/main'

export default {
  name: 'Footer',
  components: {
    RrLink
  },
  data () {
    return {
      year: new Date().getFullYear(),
      data: {
        copyright: '© Высшая Лига',
        links: [
          {
            text: 'Старты',
            link: 'https://events.topliga.ru/'
          },
          {
            text: 'Результаты',
            link: 'https://results.topliga.ru/'
          },
          {
            text: 'Фото',
            link: 'https://photo.topliga.ru/'
          },
          {
            text: 'Корпоративное участие',
            link: 'https://topliga.ru/corp'
          },
          {
            text: 'Партнерам',
            link: 'https://topliga.ru/partners'
          },
          {
            text: 'Волонтерам',
            link: 'https://topliga.ru/volunteer'
          },
          {
            text: 'Магазин',
            link: 'https://topliga.ru/shop'
          },
          {
            text: 'Контакты',
            link: 'https://topliga.ru/contacts'
          }
        ],
        socials: [
          {
            icon: 'telegram2',
            link: 'https://t.me/topligarun'
          },
          {
            icon: 'vk',
            link: 'https://vk.com/topligarun'
          },
          {
            icon: 'instagram',
            link: 'https://www.instagram.com/topligarun'
          },
          {
            icon: 'mail',
            link: 'mailto:topligacup@topliga.ru'
          },
          {
            icon: 'phone',
            link: 'tel:88003335576'
          }
        ]
      }
    }
  },
  computed: {
    copyright () {
      return this.data.copyright || ''
    },
    socials () {
      return this.data.socials || []
    },
    links () {
      return this.data.links || []
    }
  }
}
</script>

<style lang="scss" scoped>
.footer {
  background-color: #1A468E;
  color: $color-white;
  padding: 72px 0 86px;
  position: relative;
  margin-top: auto;

  &__items {
    display: grid;
    gap: 32px;
    margin: 0 -16px;

    @media (min-width: breakpoint(md)) {
      grid-template-columns: 1fr 1fr;
    }

    @media (min-width: breakpoint(lg)) {
      grid-template-columns: repeat(4, 1fr);
    }
  }

  &__item {
    padding: 0 16px;

    @media (min-width: breakpoint(md)) {
      padding: 0 20px;
    }

    ::v-deep .rr-link {
      font-weight: 400;
    }
  }

  &__social {
    display: flex;
    margin-bottom: 20px;
  }

  &__social-item {
    display: block;
    width: 24px;
    height: 24px;
    color: inherit;
    margin-right: 8px;
    max-width: 100%;

    &:hover, &:focus {
      color: $color-white;
    }
  }

  &__links {
    display: flex;
    flex-direction: column;
    gap: 12px;

    ::v-deep .rr-link {
     opacity: 1;
    }
  }

  &__logo {
    display: inline-block;
    margin-bottom: 32px;
  }
}
</style>
